import {Injectable} from '@angular/core';
import {
  AddOnErrorEvent,
  AuthenticateEvent,
  CartChangeEvent,
  ContinueEvent,
  NavigationEvent,
} from './event.interface';
import {CommerceEventEmitterService} from './commerce-event-emitter.service';
import {CartCompanionEventEmitterService} from './cart-companion-event-emitter.service';

@Injectable({
  providedIn: 'root',
})
export class EventEmitterService {
  constructor(
    private commerceEventEmitter: CommerceEventEmitterService,
    private cartCompanionEventEmitter: CartCompanionEventEmitterService,
  ) {}

  authenticate(event: AuthenticateEvent): void {
    this.commerceEventEmitter.authenticate?.emit(event);
    this.cartCompanionEventEmitter.authenticate?.emit(event);
  }

  cartLoad(event: CartChangeEvent): void {
    this.commerceEventEmitter.cartLoad?.emit(event);
    this.cartCompanionEventEmitter.cartLoad?.emit(event);
  }

  cartUpdate(event: CartChangeEvent): void {
    this.commerceEventEmitter.cartUpdate?.emit(event);
    this.cartCompanionEventEmitter.cartUpdate?.emit(event);
  }

  continue(event: ContinueEvent): void {
    this.commerceEventEmitter.continue?.emit(event);
  }

  navigation(event: NavigationEvent): void {
    this.commerceEventEmitter.navigation?.emit(event);
  }

  addOnError(event: AddOnErrorEvent): void {
    // JMB [2025-11-04]: add a pause to ensure at least one emitter is ready as errors can happen very early in the process
    const isEmitterReady = (): boolean =>
      !!this.commerceEventEmitter.addOnError ||
      !!this.cartCompanionEventEmitter.addOnError;

    if (!isEmitterReady()) {
      const maxRetries = 20;
      let attempts = 0;
      const interval = setInterval(() => {
        if (isEmitterReady()) {
          this.emitAddOnError(event);
          clearInterval(interval);
        } else if (++attempts >= maxRetries) {
          clearInterval(interval);
        }
      }, 100);
    }

    this.emitAddOnError(event);
  }

  private emitAddOnError(event: AddOnErrorEvent): void {
    this.commerceEventEmitter.addOnError?.emit(event);
    this.cartCompanionEventEmitter.addOnError?.emit(event);
  }
}
